import { FactBlock } from '@fs/zion-ui'
import React from 'react'

export default function DmcFactBlock({ heading, date = '', place = '' }) {
  if (date == null && place == null) {
    return null
  }
  return <FactBlock heading={heading} date={{ date, standardized: true }} place={{ place, standardized: true }} />
}
